export default __webpack_public_path__ + "static/greedy2-decbc61fcb94ed30de77dc234920b4a4.png";